import { toPng } from "html-to-image";
import { useState } from "react";
import {
  sectionCardStyle,
  buttonStyle,
  buttonRowStyle,
  fieldGroupStyle,
} from "../style";
import {
  AxisInput,
  LegendInput,
  AxisRangeInput,
  ZoomInput,
  FontSizeInput,
  DataSeriesCard,
  UserSettingInput,
  HeightInput,
} from "./inputerControls";
import { autoRangeFormat, save } from "./inputerUtils";

export { autoRangeFormat, minmaxTest, parseNumericInput } from "./inputerUtils";

export default function Inputer({
  graphRef,
  leftBottom,
  setLimitLeftBottom,
  rightTop,
  setLimitRightTop,
  xLabel,
  setXLabel,
  yLabel,
  setYLabel,
  datas,
  setDatas,
  legendState,
  setLegendState,
  zoomVelosity,
  setZoomVelosity,
  axisFontSize,
  setAxisFontSize,
  onLogAction,
  legendRef,
  height,
  setHeight
}) {
  const handleAddSeries = () => {
    setDatas((data) => {
      const nextData = [
        ...data,
        { name: `系列${data.length + 1}`, color: "000000", points: [],isLine:true },
      ];
      onLogAction?.("series_added", { seriesCount: nextData.length });
      return nextData;
    });
  };

  const [pngName, setPngName] = useState("graph");
  const [showDetails, setShowDetails] = useState(false);

  const legendWidth = legendRef.current?.clientWidth ?? 0;
  const legendHeight = legendRef.current?.clientHeight ?? 0;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={sectionCardStyle}>
        <div style={{ fontWeight: 700 }}>出力</div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            alignItems: "center",
          }}
        >
          <div style={fieldGroupStyle}>
            <div>PNGファイル名</div>
            <input
              type="text"
              value={pngName}
              onChange={(e) => setPngName(e.target.value)}
            />
          </div>
          <div style={buttonRowStyle}>
            <button
              onClick={() => {
                onLogAction?.("export_png", { fileName: `${pngName}.png` });
                toPng(graphRef.current, {
                  width: graphRef.current.clientWidth + 50,
                  height: graphRef.current.clientHeight + 50,
                }).then((dataUrl) => {
                  const a = document.createElement("a");
                  a.href = dataUrl;
                  a.download = `${pngName}.png`;
                  a.click();
                });
              }}
            >
              画像出力
            </button>
            <button
              onClick={() => {
                onLogAction?.("auto_range");
                autoRangeFormat(
                  datas,
                  setLimitRightTop,
                  setLimitLeftBottom,
                  xLabel,
                  yLabel,
                );
              }}
            >
              軸レンジ自動調整
            </button>
            <button
              onClick={() => {
                onLogAction?.("save");
                save(
                  datas,
                  xLabel,
                  yLabel,
                  axisFontSize,
                  legendState,
                  rightTop,
                  leftBottom,
                  zoomVelosity,
                  height
                );
              }}
            >
              保存
            </button>
          </div>
        </div>
      </div>

      <div style={sectionCardStyle}>
        <div style={{ fontWeight: 700 }}>データ系列</div>
        <div style={buttonRowStyle}></div>
        {datas.map((data, i) => (
          <DataSeriesCard
            key={i}
            data={data}
            seriesIndex={i}
            datas={datas}
            setDatas={setDatas}
            onLogAction={onLogAction}
          />
        ))}
        <button style={buttonStyle} onClick={handleAddSeries}>
          系列を追加
        </button>
      </div>

      <div style={sectionCardStyle}>
        <div style={{ fontWeight: 700 }}>グラフ設定</div>
        <LegendInput
          legendState={legendState}
          setLegendState={setLegendState}
          onLogAction={onLogAction}
          maxX={
            graphRef.current
              ? graphRef.current.clientWidth - legendWidth - 97
              : undefined
          }
          maxY={
            graphRef.current
              ? graphRef.current.clientHeight - legendHeight - 80
              : undefined
          }
        />
        <AxisInput
          axis={xLabel}
          setAxis={setXLabel}
          minValue={leftBottom}
          maxValue={rightTop}
          setMinValue={setLimitLeftBottom}
          setMaxValue={setLimitRightTop}
          axisName="x"
          onLogAction={onLogAction}
        />
        <AxisInput
          axis={yLabel}
          setAxis={setYLabel}
          minValue={leftBottom}
          maxValue={rightTop}
          setMinValue={setLimitLeftBottom}
          setMaxValue={setLimitRightTop}
          axisName="y"
          onLogAction={onLogAction}
        />
      </div>

      <div style={sectionCardStyle}>
        <button
          onClick={() => setShowDetails((prev) => !prev)}
          style={{ ...buttonStyle, alignSelf: "flex-start" }}
        >
          {showDetails ? "詳細設定を閉じる" : "詳細設定を開く"}
        </button>
        {showDetails && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <AxisRangeInput
              minValue={leftBottom}
              maxValue={rightTop}
              setMinValue={setLimitLeftBottom}
              setMaxValue={setLimitRightTop}
              axisName="x"
              onLogAction={onLogAction}
            />
            <AxisRangeInput
              minValue={leftBottom}
              maxValue={rightTop}
              setMinValue={setLimitLeftBottom}
              setMaxValue={setLimitRightTop}
              axisName="y"
              onLogAction={onLogAction}
            />
            <ZoomInput
              zoomVelosity={zoomVelosity}
              setZoomVelosity={setZoomVelosity}
              onLogAction={onLogAction}
            />
            <FontSizeInput
              axisFontSize={axisFontSize}
              setAxisFontSize={setAxisFontSize}
              legendState={legendState}
              setLegendState={setLegendState}
              onLogAction={onLogAction}
            />
            <HeightInput
              height = {height}
              setHeight = {setHeight}
              onLogAction={onLogAction}
            />
          </div>
        )}
      </div>
    </div>
  );
}
